import * as React from 'react';
import * as _ from 'lodash';  

interface UserProps {
    id: number;
    userPermissions: PermissionGroup[];
    update(userPermissions: PermissionGroup[]): void;
    save(): void;
}

interface User {
    loading: boolean;
}

interface PermissionGroup {
    groupId: number;
    group: string;
    permissions: UserPermissions[];
}

interface UserPermissions {
    id: number;
    name: string;
    groupId: number;
    selected: boolean;
}

export default class UserPermission extends React.Component<UserProps, User> {
    constructor(props: UserProps) {
        super(props);
        this.state = {
            loading: false
        }
    }

    onCheckboxChange = (groupId: number, id: number, value: boolean) => {
        var userPermissions = this.props.userPermissions;
        var userPermissionGroup = userPermissions.find(x => x.groupId === groupId);
        if (userPermissionGroup) {
            var userPermission = userPermissionGroup.permissions.find(p => p.id == id);
            if (userPermission) {
                userPermission.selected = value;
                this.props.update(userPermissions);
            }
        }
    }

    save = (e: any) => {
        e.preventDefault();
        
        this.props.save();
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderUserPermissions();


        return (<div>
            {contents}
        </div>);
    }

    renderUserPermissions = () => {
        let userPermissions = !this.props.userPermissions ? [] : this.props.userPermissions;

        return (
            <form name="user" onSubmit={this.save}>
                <div>
                    <div className="row">
                        {userPermissions.map(permissionGroup =>
                            <div key={permissionGroup.groupId}>
                                <div className="makeitbold text--large">{permissionGroup.group}</div>
                                {permissionGroup.permissions.map(permission => 
                                    <label key={permission.id} className="input-group marginLeft30" htmlFor="role">
                                        <input type='checkbox' className="input-control user__checkboxPosition marginRight10" checked={permission.selected} onChange={(e) => this.onCheckboxChange(permissionGroup.groupId, permission.id, e.target.checked)} />
                                        <span className="label label-unlimited user__checkboxLabelPosition">{permission.name}</span>
                                    </label>
                                )}
                            </div>
                        )}
                    </div>

                    <div className="row">
                        <button className="defaultbutton-next" type="submit">Save</button>
                    </div>

                </div>
            </form>
        );
    }

}